module.exports = __webpack_public_path__ + "static/media/Assets-03-VirtualSurgery-Exhibition-01.1e8ed767.mp4";